import React from 'react';
import { education } from '../data/mock';
import { GraduationCap, MapPin, Calendar } from 'lucide-react';
import '../styles/Education.css';

const Education = () => {
  return (
    <section className="education-section" id="education">
      <div className="education-container">
        <h2 className="section-title">Education</h2>
        
        <div className="education-grid">
          {education.map((edu) => (
            <div key={edu.id} className="education-card">
              <div className="education-icon">
                <GraduationCap size={32} />
              </div>
              
              <div className="education-content">
                <h3 className="education-institution">{edu.institution}</h3>
                <p className="education-degree">{edu.degree}</p>
                
                <div className="education-meta">
                  <div className="education-meta-item">
                    <Calendar size={16} />
                    <span>{edu.period}</span>
                  </div>
                  <div className="education-meta-item">
                    <MapPin size={16} />
                    <span>{edu.location}</span>
                  </div>
                  {edu.gpa && (
                    <div className="education-meta-item gpa">
                      <span>GPA: {edu.gpa}</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Education;